export default __webpack_public_path__ + "static/media/Avatar-4.56074877.png";